module.exports = __webpack_public_path__ + "img/icy cool home.b559c061.png";